const KLAVIYO_BIS_URL =
  'https://a.klaviyo.com/client/back-in-stock-subscriptions/';
// Revisionen måste vara 2025-01-15 eller senare. Äldre revisioner svarar
// 400 "'subscriptions' is not a valid field for the resource 'profile'" på
// samtyckes-anropet nedan. Verifierat mot API:et 2026-10-23.
const KLAVIYO_REVISION = '2026-07-15';

// The catalog variant id Klaviyo expects: `$custom:::$default:::<external id>`.
// The external id must match what the catalog feed sends to Klaviyo. We assume
// the Jetshop article number; change this one function if the feed differs.
export const buildKlaviyoVariantId = articleNumber =>
  `$custom:::$default:::${articleNumber}`;

// Subscribes a profile to a variant. Resolves on Klaviyo's 202, throws
// otherwise with the status and the errors array Klaviyo returned.
export async function subscribeToKlaviyoBackInStock({
  companyId,
  email,
  articleNumber
}) {
  const url = `${KLAVIYO_BIS_URL}?company_id=${encodeURIComponent(companyId)}`;
  const body = {
    data: {
      type: 'back-in-stock-subscription',
      attributes: {
        channels: ['EMAIL'],
        profile: {
          data: {
            type: 'profile',
            attributes: { email }
          }
        }
      },
      relationships: {
        variant: {
          data: {
            type: 'catalog-variant',
            id: buildKlaviyoVariantId(articleNumber)
          }
        }
      }
    }
  };

  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      revision: KLAVIYO_REVISION
    },
    body: JSON.stringify(body)
  });

  if (!res.ok) {
    let details = null;
    try {
      details = await res.json();
    } catch (parseError) {
      details = null;
    }
    const error = new Error(`Klaviyo back in stock failed (${res.status})`);
    error.status = res.status;
    error.details = details && details.errors ? details.errors : details;
    throw error;
  }
}

const KLAVIYO_SUBSCRIPTION_URL = 'https://a.klaviyo.com/client/subscriptions/';

// Gives the profile e-mail marketing consent on a list. A back-in-stock mail
// counts as marketing and cannot be sent as transactional, so a profile that
// never consented, or unsubscribed earlier, would otherwise be skipped by the
// flow. Only ever called when the customer ticked the box themselves.
export async function subscribeToKlaviyoList({ companyId, email, listId }) {
  const url = `${KLAVIYO_SUBSCRIPTION_URL}?company_id=${encodeURIComponent(
    companyId
  )}`;
  const body = {
    data: {
      type: 'subscription',
      attributes: {
        custom_source: 'Back in stock form',
        profile: {
          data: {
            type: 'profile',
            attributes: {
              email,
              subscriptions: {
                email: { marketing: { consent: 'SUBSCRIBED' } }
              }
            }
          }
        }
      },
      relationships: {
        list: { data: { type: 'list', id: listId } }
      }
    }
  };

  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      revision: KLAVIYO_REVISION
    },
    body: JSON.stringify(body)
  });

  if (!res.ok) {
    let details = null;
    try {
      details = await res.json();
    } catch (parseError) {
      details = null;
    }
    const error = new Error(`Klaviyo list subscription failed (${res.status})`);
    error.status = res.status;
    error.details = details && details.errors ? details.errors : details;
    throw error;
  }
}
